import React from 'react'

export const AccountDetails = () => {
  return (
    <div>AccountDetails</div>
  )
}
